import { render, staticRenderFns } from "./IconItalic.vue?vue&type=template&id=42a7cd6c"
import script from "./IconItalic.vue?vue&type=script&lang=js"
export * from "./IconItalic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports